import { ReportSourceId, ReportSourceRequest, ReportSourceResponse } from '@business/entities/ReportSource/ReportSourceResponse';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';

/**
 * Support Channel API
 */
export function fetchAllItems() {
  return Endpoint.get<ReportSourceResponse[]>(`@gc/report-source`);
}

export function fetchItem(id: ReportSourceId) {
  return Endpoint.get<ReportSourceResponse>(`@gc/report-source/${id}`);
}

export function createItem(data: Partial<ReportSourceRequest>) {
  return Endpoint.post<ReportSourceResponse>(`@gc/report-source`, { data: { ...data } });
}

export function updateItem(id: ReportSourceId, data: Partial<ReportSourceRequest>) {
  return Endpoint.patch<ReportSourceResponse>(`@gc/report-source/${id}`, { data: { ...data } });
}

export function loadDataFromURL(file: File) {
  const formData = CommonService.toFormData({ file });
  return Endpoint.post<ReportSourceResponse>(`@gc/report-source/load-file`, { formData, hasFiles: true });
}
export function deleteItem(id: ReportSourceId) {
  return Endpoint.delete<void>(`@gc/report-source/${id}`);
}
